<template>
    <error-screen />
</template>

<script setup lang="ts">
    definePageMeta({ layout: 'default-no-header' });
</script>